import { useGetApiV1MissionsMissionIdControl } from '@/shared/api/generated/missions/missions';
import { useCurrentUserId } from '@/features/auth/model/use-roles';
import { LiveEvery, liveEvery } from '@/shared/lib/live';

/**
 * Whether the signed-in operator holds **this mission's** open shift (§23.1).
 *
 * ⚠️ **Not a role check, and the difference is the whole point.** Every Desk Control operator passes
 * the control policy — that is what lets them answer a mission's offer at all — so a role check
 * would draw the remove, leader and announce controls for every operator looking at the mission,
 * and every one of those clicks would come back 403. This is exactly the test the server applies.
 *
 * ⚠️ The Head of Control is not special-cased here either, matching the server: §23.1 has them
 * following a mission until an owner is assigned, and the way to follow one is to take the watch.
 *
 * Shared across the panels on the mission page, so the underlying query runs once.
 */
export function useIsMissionControl(missionId: string): boolean {
  const me = useCurrentUserId();
  const control = useGetApiV1MissionsMissionIdControl(missionId, liveEvery(LiveEvery.work));

  return me != null && control.data?.holder?.userId === me;
}
